import { createApi } from "@reduxjs/toolkit/query/react";
import { createContactEndpoints } from "./endpoints/contact.endpoints";
import { createGameParticipantEndpoints } from "./endpoints/gameParticipant.endpoint";
import { createNewsEndpoints } from "./endpoints/news.endpoints";
import { storeLocatorSearchEndpoint } from "./endpoints/storeLocatorSearch.endpoints";
import { createWidgetEndpoint } from "./endpoints/widget.endpoints";
import { createZendeskEndpoints } from "./endpoints/zendesk.endpoints";
import { createDiscountProductEndpoints } from "@src/lib/DiscountProduct/endpoints/discountProduct.endpoints";
import { baseQueryFn } from "./baseQuery";

/**
 * API RTK chargée en parallèle : Zendesk, widgets CMS, actus, jeu, contact, magasins (recherche), promos.
 * Chunk séparé côté bundle → moins de JS à parser sur le chemin critique des pages simples.
 */
export const rolligStartExtendedApi = createApi({
  reducerPath: "rollingStartExtendedApi",
  baseQuery: baseQueryFn,
  endpoints: (builder) => ({
    ...createZendeskEndpoints(builder),
    ...createWidgetEndpoint(builder),
    ...createNewsEndpoints(builder),
    ...createGameParticipantEndpoints(builder),
    ...createContactEndpoints(builder),
    ...createDiscountProductEndpoints(builder),
    ...storeLocatorSearchEndpoint(builder),
  }),
});

export const {
  useLazyGetStoreLocatorSearchQuery,
  useLazyGetStoreClosureQuery,
  usePostZendeskContactMutation,
  useLazyGetZendeskSearchQuery,
  useLazyGetWidgetInstanceQuery,
  useLazyGetWidgetGroupQuery,
  useLazyGetNewsItemQuery,
  useAddGameParticipantMutation,
  useUpdateContactMutation,
  useLazyGetDiscountProductOfferedQuery,
  useLazyGetDiscountKxmQuery,
  useGetDiscountNudgeVAEQuery,
  useLazyGetDiscountNudgeVAEQuery,
} = rolligStartExtendedApi;
